import { useMemo } from 'react'

import { Grid } from '@mui/material'

import { TextInput } from 'components/common'
import { BookingStatus } from 'generated/graphql'

import ContainerStatus from './ContainerStatus'
import ContainerTitle from './ContainerTitle'
import PobPodButtons from './PobPodButtons'

export type SupplierBookingDetailsProps = {
  bookingId?: string
  statusLabel: string
  customerName: string
  customerReference: string
  ourReference: string
  status?: BookingStatus
}

interface ISupplierMainBookingDetailsProps {
  bookingDetails: SupplierBookingDetailsProps
  loading?: boolean
  disabled: boolean
}

const SupplierMainBookingDetails = (props: ISupplierMainBookingDetailsProps) => {
  const { bookingDetails, disabled } = props
  const isPobPodButtonsDisabled = useMemo(
    () => !bookingDetails.status || bookingDetails.status === BookingStatus.Waiting,
    [bookingDetails.status],
  )

  return (
    <div>
      <Grid container justifyContent='space-between'>
        <ContainerTitle isQuote={false} disabled={disabled} />

        <ContainerStatus bookingStatus={bookingDetails.statusLabel} />
      </Grid>

      <Grid container spacing={1.5}>
        <Grid
          item
          xs={12}
          md='auto'
          alignSelf='center'
          ml={{ lg: 'auto' }}
          sx={{ order: { xs: 3, md: 1, lg: 6 } }}>
          <PobPodButtons
            hoverText=''
            disabled={disabled}
            isPobPodButtonsDisabled={isPobPodButtonsDisabled}
            bookingId={bookingDetails.bookingId}
          />
        </Grid>

        {/* Customer data */}
        <Grid
          container
          item
          xs={12}
          sm={6}
          md={12}
          lg={6.7}
          xl={7}
          sx={{ order: { xs: 4, lg: 1 } }}>
          <Grid container spacing={0.5}>
            <Grid item xs zeroMinWidth>
              <TextInput label='Customer' readOnly value={bookingDetails.customerName} />
            </Grid>

            <Grid item xs={12} md>
              <TextInput
                label='Cust. Ref. / PO number'
                readOnly
                value={bookingDetails.customerReference}
              />
            </Grid>

            <Grid item xs={12} md>
              <TextInput label='Booking Ref' readOnly value={bookingDetails.ourReference} />
            </Grid>
          </Grid>
        </Grid>

      </Grid>
    </div>
  )
}

export default SupplierMainBookingDetails
